import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AggiornamentoAlboComponent } from './components/aggiornamento-albo/aggiornamento-albo.component';
import { ImportIscrittiComponent } from './components/import-iscritti/import-iscritti.component';
import { BaseCompetenzeListResolver, CancellatiResolver, CaricaAllegatiResolver, CaricaBozzaResolver, CronologieIscritto, DeliberaResolver, DelibereElenecoResolver, DropdownFiltriAvanzati, DropdownFiltriAvanzatiExport, DropdwonDataResolver, InviateListResolver, IscrittiContabCancellatiResolver, IscrittiContabResolver, IscrittiDeliberaChiusa, IscrittiResolver, IscrittoDropdwonDataResolver, IscrittoQuoteListResolver, IscrittoReadonlyDataResolver, IscrittoReadonlyDataTelefoniResolver, IscrittoResolver, LavorateListResolver, ProvvisoriDeliberaResolver, ProvvisoriResolver, QuoteResolver, ruoloSocioListResolver, SollecitiListResolver, SollecitoCorrenteResolver, SpeseAmministrativeCorrentiResolver, StatiIscrittoAttiviResolver,  StatiIscrittoNonAttiviResolver, StpContabListResolver, StpDropdownDataResolver, StpFiltersResolver, StpIscrittiResolver, StpIscrittoResolver, StpListResolver, StpQuoteResolver, StpResolver, TipiDeliberaResolver, tipoSocioListResolver, UltimoNumeroIscrizioneResolver } from './services/resolver.service';
import { DettaglioIscrittoComponent } from './components/dettaglio-iscritto/dettaglio-iscritto.component';
import { DettaglioStpComponent } from './components/dettaglio-stp/dettaglio-stp.component';
import { DettaglioContabileComponent } from './components/dettaglio-contabile/dettaglio-contabile.component';
import { ConfigurazioneComponent } from './components/configurazione/configurazione.component';
import { AuthGuard } from './guards/auth-guard.guard';
import { TabellaIscrittiComponent } from './components/tabella-iscritti/tabella-iscritti.component';
import { TabellaProvvisoriComponent } from './components/tabella-provvisori/tabella-provvisori.component';
import { TabellaCancellatiComponent } from './components/tabella-cancellati/tabella-cancellati.component';
import { TabellaStpComponent } from './components/tabella-stp/tabella-stp.component';
import { TabellaDelibereComponent } from './components/tabella-delibere/tabella-delibere.component';
import { TabellaDelibereABComponent } from './components/tabella-delibere-a-b/tabella-delibere-a-b.component';
import { TabellaProvvisoriFinalizzatiComponent } from './components/tabella-provvisori-finalizzati/tabella-provvisori-finalizzati.component';
import { TabellaContabilitaComponent } from './components/tabella-contabilita/tabella-contabilita.component';
import { ImportPagamentiComponent } from './components/import-pagamenti/import-pagamenti.component';
import { GeneraIuvComponent } from './components/genera-iuv/genera-iuv.component';
import { TabellaDelibereFinalizzaComponent } from './components/tabella-delibere-finalizza/tabella-delibere-finalizza.component';
import { TabellaDelibereChiuseComponent } from './components/tabella-delibere-chiuse/tabella-delibere-chiuse.component';
import { TabellaProvvisoriFinalizzareComponent } from './components/tabella-provvisori-finalizzare/tabella-provvisori-finalizzare.component';
import { TabellaContabCancellatiComponent } from './components/tabella-contab-cancellati/tabella-contab-cancellati.component';
import { TabellaDeliberePsiAComponent } from './components/tabella-delibere-psi-a/tabella-delibere-psi-a.component';
import { TabellaDelibereTrasfComponent } from './components/tabella-delibere-trasf/tabella-delibere-trasf.component';
import { SpeseAmministrativeComponent } from './components/spese-amministrative/spese-amministrative.component';
import { StampeEDelibereComponent } from './components/stampe-e-delibere/stampe-e-delibere.component';
import { TabellaGestioneDomandeComponent } from './components/tabella-gestione-domande/tabella-gestione-domande.component';
import { TabellaStoricoDomandeComponent } from './components/tabella-storico-domande/tabella-storico-domande.component';
import { DettaglioDomandaIscrizioneComponent } from './components/dettaglio-domanda-iscrizione/dettaglio-domanda-iscrizione.component';
import { DettaglioStpSocioComponent } from './components/dettaglio-stp-socio/dettaglio-stp-socio.component';
import { TabellaContabStpComponent } from './components/tabella-contab-stp/tabella-contab-stp.component';
import { DettaglioContabileStpComponent } from './components/dettaglio-contabile-stp/dettaglio-contabile-stp.component';
import { environment } from './environment/environment';
import { GestioneCompetenzeComponent } from './components/gestione-competenze/gestione-competenze.component';
import { ConfigurazioneSollecitoComponent } from './components/configurazione-sollecito/configurazione-sollecito.component';
import { RegistroComunicazioniComponent } from './components/registro-comunicazioni/registro-comunicazioni.component';
import { RegistroPagamentiComponent } from './components/registro-pagamenti/registro-pagamenti.component';
import { ImportGuard } from './guards/import-guard.guard';
import { DomandeGuard } from './guards/domande-guard.guard';
import { ExportAvanzatoComponent } from './components/export-avanzato/export-avanzato.component';
import { ExportCasellarioComponent } from './components/export-casellario/export-casellario.component';

const regione = environment.regione;

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()}`,
    data: {
      roles: ['albo', 'consultazione', 'iscrizioni', 'contabilita', 'deontologico'],
      title: 'dashboard.titolo',
    }
  },
  {
    path: 'gestione_albo/gestione_iscritti/:routeFilters',
    component: TabellaIscrittiComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Gestione Iscritti`,
    data: { roles: ['albo','consultazione'], title: 'gestioneAlbo.gestioneIscritti.titolo', componente: 'iscritti' },
    resolve: {
      'iscritti': IscrittiResolver,
      'statiIscritto': StatiIscrittoAttiviResolver,
      'dropdown': DropdownFiltriAvanzati
    }
  },
  {
    path: 'gestione_albo/gestione_iscritti/dettaglio_iscritto/:id',
    component: DettaglioIscrittoComponent,
    canActivate: [AuthGuard],
    canDeactivate: [(component: DettaglioIscrittoComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
      return component.unsavedChecker().then(() => true).catch(() => false);
    }],
    title: `Albo ${regione.toUpperCase()} | Dettaglio Iscritto`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], nuovoIscritto: false, title: 'gestioneAlbo.dettaglioIscritto.titolo' },
    resolve: {
      'iscritto': IscrittoResolver,
      'quote': QuoteResolver,
      'iscrittoDropdown': IscrittoDropdwonDataResolver,
      'cronologie': CronologieIscritto
    }
  },
  {
    path: 'gestione_albo/nuovo_iscritto',
    component: DettaglioIscrittoComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Nuovo Iscritto`,
    canDeactivate: [(component: DettaglioIscrittoComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
      return component.unsavedChecker().then(() => true).catch(() => false);
    }],
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], nuovoIscritto: true, title: 'gestioneAlbo.dettaglioIscritto.titoloNuovo', provvisorio: false },
    resolve: {
      'iscrittoDropdown': IscrittoDropdwonDataResolver,
      'ultimoNumeroIscrizione': UltimoNumeroIscrizioneResolver
    }
  },
  {
    path: 'gestione_albo/provvisori',
    component: TabellaProvvisoriComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Provvisori`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneAlbo.provvisori.titolo', componente: 'provvisori' },
    resolve: { 'provvisori': ProvvisoriResolver }
  },
  {
    path: 'gestione_albo/nuovo_provvisorio',
    component: DettaglioIscrittoComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Nuovo Iscritto`,
    canDeactivate: [(component: DettaglioIscrittoComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
      return component.unsavedChecker().then(() => true).catch(() => false);
    }],
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], nuovoIscritto: true, title: 'gestioneAlbo.provvisori.titoloNuovo', provvisorio: true },
    resolve: {
      'iscrittoDropdown': IscrittoDropdwonDataResolver,
      'ultimoNumeroIscrizione': UltimoNumeroIscrizioneResolver
    }
  },
  {
    path: 'gestione_albo/stp',
    component: TabellaStpComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | STP`,
    data: { roles: ['albo','consultazione'], title: 'gestioneAlbo.societa.titolo', componente: 'stpList' },
    resolve: { 'listaStp': StpListResolver }
  },
  {
    path: 'gestione_albo/stp/dettaglio_stp/:id',
    component: DettaglioStpComponent,
    canActivate: [AuthGuard],
    canDeactivate: [(component: DettaglioStpComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
      return component.unsavedChecker().then(() => true).catch(() => false);
    }],
    title: `Albo ${regione.toUpperCase()} | Stp Dettaglio`,
    data: { roles: ['albo','consultazione'], nuovoStp: false, title: 'gestioneAlbo.dettaglioStp.titolo' },
    resolve: {
      'stp': StpResolver,
      'stp_iscritti': StpIscrittiResolver,
      'stpFilters': StpFiltersResolver,
      'dropdown': StpDropdownDataResolver,
      'quote-stp': StpQuoteResolver
    }
  },
  {
    path: 'gestione_albo/stp/nuova_stp',
    component: DettaglioStpComponent,
    canActivate: [AuthGuard],
    canDeactivate: [(component: DettaglioStpComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
      return component.unsavedChecker().then(() => true).catch(() => false);
    }],
    title: `Albo ${regione.toUpperCase()} | Nuova Stp`,
    data: {roles: ['albo'], nuovoStp: true, title: 'gestioneAlbo.dettaglioStp.titoloNuovo' },
    resolve: { 'dropdown': StpDropdownDataResolver }
  },
  {
    path: 'gestione_albo/stp/dettaglio_stp/:idStp/nuovo_socio',
    component: DettaglioStpSocioComponent,
    canActivate: [AuthGuard],
    // canDeactivate: [(component: DettaglioStpSocioComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
    //   return component.unsavedChecker().then(() => true).catch(() => false);
    // }],
    title: `Albo ${regione.toUpperCase()} | Nuovo Socio`,
    data: { roles: ['albo'], nuovoSocio: true, title: 'gestioneAlbo.dettaglioStp.titoloSocioNuovo' },
    resolve: {
      'dropdown': StpDropdownDataResolver,
      'tipoSocioList': tipoSocioListResolver,
      'ruoloSocioList': ruoloSocioListResolver
    }
  },
  {
    path: 'gestione_albo/stp/dettaglio_stp/:idStp/dettaglio_socio/:id',
    component: DettaglioStpSocioComponent,
    canActivate: [AuthGuard],
    // canDeactivate: [(component: DettaglioStpSocioComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState: RouterStateSnapshot) => {
    //   return component.unsavedChecker().then(() => true).catch(() => false);
    // }],
    title: `Albo ${regione.toUpperCase()} | Socio Stp`,
    data: { roles: ['albo'], nuovoSocio: false, title: 'gestioneAlbo.dettaglioStp.titoloSocio' },
    resolve: {
      'socio': StpIscrittoResolver,
      'dropdown': StpDropdownDataResolver,
      'tipoSocioList': tipoSocioListResolver,
      'ruoloSocioList': ruoloSocioListResolver
    }
  },
  {
    path: 'gestione_albo/cancellati',
    component: TabellaCancellatiComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Iscritti Cancellati`,
    data: { roles: ['albo','consultazione'], title: 'gestioneAlbo.cancellati.titolo', componente: 'cancellati' },
    resolve: { 'cancellati': CancellatiResolver, 'statiIscritto': StatiIscrittoNonAttiviResolver }
  },
  {
    path: 'delibere/gestione',
    component: TabellaDelibereComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloGestione', componente: 'delibere' },
    resolve: {
      'delibere': DelibereElenecoResolver,
      'tipiDelibera': TipiDeliberaResolver }
  },
  {
    path: 'delibere/finalizzazione',
    component: TabellaDelibereFinalizzaComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloFinalizzazione', componente: 'delibereFinalizzate' },
    resolve: {
      'delibere': DelibereElenecoResolver,
      'tipiDelibera': TipiDeliberaResolver
    }
  },
  {
    path: 'delibere/chiuse',
    component: TabellaDelibereChiuseComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloChiusi', componente: 'delibereChiuse' },
    resolve: {
      'delibere': DelibereElenecoResolver,
      'tipiDelibera': TipiDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/A/:id',
    component: TabellaDelibereABComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoA', componente: 'provvisori_a' },
    resolve: {
      'delibera': DeliberaResolver,
      'provvisori_a': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/B/:id',
    component: TabellaDelibereABComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoB', componente: 'provvisori_b' },
    resolve: {
      'delibera': DeliberaResolver,
      'provvisori_b': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/C/:id',
    component: TabellaDelibereABComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoC', componente: 'cambio_sezione' },
    resolve: {
      'delibera': DeliberaResolver,
      'cambio_sezione': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/P/:id',
    component: TabellaDeliberePsiAComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoAP', componente: 'psi_a' },
    resolve: {
      'delibera': DeliberaResolver,
      'psi_a': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/T/:id',
    component: TabellaDelibereTrasfComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoT', componente: 'trasferimento' },
    resolve: {
      'delibera': DeliberaResolver,
      'trasferimento': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/finalizza/A/:id',
    component: TabellaProvvisoriFinalizzareComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoA', componente: 'provvisori_a_finalizza' },
    resolve: {
      'delibera': DeliberaResolver,
      'provvisori_a_finalizza': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/finalizza/B/:id',
    component: TabellaProvvisoriFinalizzareComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoB', componente: 'provvisori_b_finalizza' },
    resolve: {
      'delibera': DeliberaResolver,
      'provvisori_b_finalizza': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/finalizza/C/:id',
    component: TabellaProvvisoriFinalizzareComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoC', componente: 'cambio_sezione_finalizza' },
    resolve: {
      'delibera': DeliberaResolver,
      'cambio_sezione_finalizza': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/finalizza/P/:id',
    component: TabellaProvvisoriFinalizzareComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoAP', componente: 'psi_a_finalizza' },
    resolve: {
      'delibera': DeliberaResolver,
      'psi_a_finalizza': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/finalizza/T/:id',
    component: TabellaProvvisoriFinalizzareComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloRiepilogoT', componente: 'trasferimento_finalizza' },
    resolve: {
      'delibera': DeliberaResolver,
      'trasferimento_finalizza': ProvvisoriDeliberaResolver
    }
  },
  {
    path: 'delibere/dettaglio_delibera/iscrizione_chiusa/:id',
    component: TabellaProvvisoriFinalizzatiComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Delibere`,
    data: { roles: ['albo', 'consultazione', 'iscrizioni'], title: 'gestioneProvvisori.titoloChiusi', componente: 'delibera_chiusa' },
    resolve: {
      'delibera': DeliberaResolver,
      'delibera_chiusa': IscrittiDeliberaChiusa
    }
  },
  {
    path: 'stampe_e_delibere',
    component: StampeEDelibereComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['albo', 'iscrizioni', 'consultazione'], title: 'stampeDelibere.titolo' }
  },
  {
    path: 'domande_iscrizione/gestione',
    component: TabellaGestioneDomandeComponent,
    canActivate: [AuthGuard, DomandeGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['albo', 'iscrizioni', 'consultazione'], title: 'domandeIscrizione.gestioneTitolo', componente: 'gestione_domande_iscrizione' },
    resolve: {
      'inviateList': InviateListResolver
    }
  },
  {
    path: 'domande_iscrizione/storico',
    component: TabellaStoricoDomandeComponent,
    canActivate: [AuthGuard, DomandeGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['albo', 'iscrizioni', 'consultazione'], title: 'domandeIscrizione.storicoTitolo', componente: 'storico_domande_iscrizione' },
    resolve: {
      'finalizzateList': LavorateListResolver
    }
  },
  {
    path: 'domande_iscrizione/dettaglio_domanda/:id',
    component: DettaglioDomandaIscrizioneComponent,
    canActivate: [AuthGuard, DomandeGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['albo', 'iscrizioni', 'consultazione'], title: 'domandeIscrizione.dettaglioDomanda.titolo', componente: 'domanda', allegati: 'allegati' },
    resolve: {
      'domanda': CaricaBozzaResolver,
      'allegati': CaricaAllegatiResolver
    }
  },
  {
    path: 'domande_iscrizione/storico/dettaglio_pratica/:id',
    component: DettaglioDomandaIscrizioneComponent,
    canActivate: [AuthGuard, DomandeGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['albo', 'iscrizioni', 'consultazione'], title: 'domandeIscrizione.dettaglioDomanda.titoloPratica', componente: 'storico_pratica', allegati: 'allegati' },
    resolve: {
      'storico_pratica': CaricaBozzaResolver,
      'allegati': CaricaAllegatiResolver
    }
  },
  {
    path: 'contabilita_iscritti/:routeFilters',
    component: TabellaContabilitaComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Contabilità Iscritti`,
    data: { roles: ['contabilita', 'consultazione'], title: 'contabilita.contabilitaIscritti.titolo', componente: 'contabile' },
    resolve: { 'contabile': IscrittiContabResolver }
  },
  {
    path: 'contabilita_iscritti_cancellati/:routeFilters',
    component: TabellaContabCancellatiComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Contabilità Iscritti Cancellati`,
    data: { roles: [ 'contabilita', 'consultazione'], title: 'contabilita.cancellatiRadiati.titolo', componente: 'contabile-cancellati' },
    resolve: { 'contabile-cancellati': IscrittiContabCancellatiResolver }
  },
  {
    path: 'contabilita_iscritti/dettaglio_iscritto/:id',
    component: DettaglioContabileComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Contabilità Iscritti`,
    data: { roles: [ 'contabilita', 'consultazione'], title: 'contabilita.titoloDettaglio' },
    resolve: {
      'iscritto': IscrittoQuoteListResolver,
      'iscrittoReadonlyData': IscrittoReadonlyDataResolver,
      'numeriSecondari': IscrittoReadonlyDataTelefoniResolver
     }
  },
  {
    path: 'contabilita_stp',
    component: TabellaContabStpComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Contabilità STP`,
    data: { roles: ['contabilita', 'consultazione'], title: 'contabilita.contabilitaStp.titolo', componente: 'contabile-stp' },
    resolve: {
      'lista': StpContabListResolver
    }
  },
  {
    path: 'contabilita_stp/dettaglio_contabile/:id',
    component: DettaglioContabileStpComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Dettaglio Contabilità STP`,
    data: { roles: ['contabilita', 'consultazione'], title: 'contabilita.titoloDettaglioStp', componente: 'contabile-stp' },
    resolve: {
      'stp': StpResolver
    }
  },
  {
    path: 'contabilita/spese_amministrative',
    component: SpeseAmministrativeComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['contabilita', 'consultazione'], title: 'contabilita.speseAmministrative.titolo', componente: 'spese-amministrative' },
    resolve: {
      'speseAmministrativeCorrenti': SpeseAmministrativeCorrentiResolver
    }
  },
  {
    path: 'contabilita/genera_iuv',
    component: GeneraIuvComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: [ 'contabilita', 'consultazione'], title: 'contabilita.generaIuv.titolo' }
  },
  {
    path: 'contabilita/import_pagamenti',
    component: ImportPagamentiComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | `,
    data: { roles: ['contabilita', 'consultazione'], title: 'contabilita.importaPagamenti.titolo' }
  },
  {
    path: 'contabilita/configurazione-solleciti',
    component: ConfigurazioneSollecitoComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Solleciti`,
    data: {
      roles: ['contabilita'],
      title: 'contabilita.configuraSolleciti.titolo'
    },
    resolve: {
      'sollecitoCorrente': SollecitoCorrenteResolver,
      'sollecitiList': SollecitiListResolver
    }
  },
  {
    path: 'export_avanzato',
    component: ExportAvanzatoComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Export Avanzato`,
    data: { roles: ['albo','contabilita', 'consultazione'], title: 'export.avanzato.titolo', componente: 'iscritti' },
    resolve: {
      'dropdown': DropdownFiltriAvanzatiExport
    }
  },
  {
    path: 'export_casellario',
    component: ExportCasellarioComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Export Casellario`,
    data: { roles: ['albo','contabilita'], title: 'export.casellario.titolo', componente: 'iscritti' },
    resolve: {
      'iscritti': IscrittiResolver,
      'statiIscritto': StatiIscrittoAttiviResolver
    }
  },
  {
    path: 'aggiornamento_nazionale',
    component: AggiornamentoAlboComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Aggiornamento Albo Nazionale`,
    data: { roles: ['albo', 'consultazione'], title: 'aggiornamentoNazionale.titolo' }
  },
  {
    path: 'import_iscritti',
    component: ImportIscrittiComponent,
    canActivate: [AuthGuard, ImportGuard],
    title: `Albo ${regione.toUpperCase()} | Import Provvisori`,
    data: { roles: ['iscrizioni', 'consultazione'], title: 'importIscritti.titolo' }
  },
  {
    path: 'registro-comunicazioni',
    component: RegistroComunicazioniComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Registro comunicazioni`,
    data: {
      roles: ['albo', 'iscrizioni', 'contabilita','consultazione'],
      title: 'registri.comunicazioni.titolo'
    },
  },
  {
    path: 'registro-pagamenti',
    component: RegistroPagamentiComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Registro pagamenti`,
    data: {
      roles: ['albo', 'iscrizioni', 'contabilita','consultazione'],
      title: 'registri.pagamenti.titolo'
    },
  },
  {
    path: 'configurazione/liste-valori',
    component: ConfigurazioneComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Configurazione`,
    data: {
      roles: ['configurazione'],
      title: 'configurazione.listeValori.titolo'
    },
    resolve: { 'dropdown': DropdwonDataResolver }
  },
  {
    path: 'configurazione/competenze',
    component: GestioneCompetenzeComponent,
    canActivate: [AuthGuard],
    title: `Albo ${regione.toUpperCase()} | Configurazione`,
    data: {
      roles: ['configurazione'],
      title: 'configurazione.competenze.titolo'
    },
    resolve: { 'baseCompetenzeList': BaseCompetenzeListResolver }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

